// The employee_contact column list, in one place.
//
// It used to be written out by hand in three screens. When the intake migration
// (20260805100000_intake_contact.sql) added dob and the next-of-kin columns, two
// of the three were updated and MeScreen was missed — so employees filled the
// fields in at first login, HR could see them, and the employee could not. Adding
// column #8 should be a one-line change here, not a hunt.
//
// The select string is the source and the array is derived, not the other way
// round: postgrest-js infers the row shape from a *literal* select, and a value
// built with .join() is just `string`, which collapses the result type to
// GenericStringError at every call site.
export const CONTACT_SELECT =
  'mobile, personal_email, address, dob, emergency_name, emergency_relation, emergency_phone' as const;

export const CONTACT_COLS: readonly string[] = CONTACT_SELECT.split(', ');

const COL_SET: ReadonlySet<string> = new Set(CONTACT_COLS);

/**
 * Keep only real employee_contact columns.
 *
 * MeScreen's contact delta is a union of two tables — location, joined and
 * job_description live on `profiles` and are routed there separately. Sending
 * one of them to employee_contact fails the whole upsert, so this filter is
 * what keeps a "Location" edit from breaking every other field on the card.
 */
export const contactCols = <T extends object>(delta: T): Record<string, unknown> =>
  Object.fromEntries(Object.entries(delta).filter(([k]) => COL_SET.has(k)));
